import { LoginForm } from 'components';

export const Login = () => {
  return <LoginForm />;
};
